import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGitBranchIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M3.75 13V11M3.75 3V11M3.75 11V11C3.75 9.34315 5.09315 8 6.75 8H9.25C10.9069 8 12.25 6.65685 12.25 5V3" }), /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 3.75,
				cy: 3.25,
				r: 1
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 3.75,
				cy: 12.75,
				r: 1
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 12.25,
				cy: 3.25,
				r: 1
			})
		]
	})]
});
export default SvgGitBranchIcon;
